import {Component, Vue} from 'vue-facing-decorator';
import store from '../../../store';
import {sendPopupRequest} from '../../../utils/portuna';
import dateHelper from '../../../utils/portuna/dateHelper';
import {Popup} from '../../popup';
import TopMessageHandler from '../../topMessageHandler';
import {INSIGHT_ATTRIBUTES} from '../employee';

export const statusText: { [key: number]: string } = {
    1: 'Absage durch den Sachbearbeiter schicken.',
    2: 'Rückfragen durch den Sachbearbeiter klären.',
    3: 'Bewerbung bearbeiten.', //  HA:
    4: 'Bewerber zum Bewerbungsgespräch einladen.',
    5: 'Bewerbung zum Entscheider weiterleiten.',
    6: 'Bewerber hat die Bewerbung zurückgezogen.',
    7: 'Absage senden.', // BO:
    8: 'Bewerbungsprozess erneut starten.',
    9: 'Absage gesendet, Bewerbung deaktivieren.',
    10: 'Rückfragen klären.',// BO:
    11: 'Rückfragen geklärt.',
    12: 'Abgelehnt durch den Sachbearbeiter.',
    13: 'Termin-Anfrage stellen.',// BO:
    14: 'Bewerber nicht erreicht.',
    15: 'Termin angelegt & Bewerber informiert.',
    16: 'Warten auf Gesprächsresultat.', //  HA:
    17: 'Erneuten Gesprächstermin vereinbaren.',
    18: 'Kennenlerntag vereinbaren.',
    19: 'Bewerbung deaktiviert.',// BO:
    20: 'Kennenlerntag vereinbaren.',// BO:
    21: 'Bewerber nicht erreicht.',
    22: 'Kennenlerntag vereinbart.',
    23: 'Kennenlerntag findet noch statt.', //  HA:
    24: 'Weitere Informationen durch den Sachbearbeiter erfragen.',
    25: 'Vertragstermin durch den Sachbearbeiter vereinbaren.',
    26: 'Weitere Informationen beschaffen.',// BO:
    27: 'Informationen Weiterleiten.',
    28: 'Termin zur Vertragsunterzeichnung erstellen.',// BO:
    29: 'Abgelehnt durch den Sachbearbeiter.',// BO:
    30: 'Vertragsunterzeichnungs-Termin erstellt.',// BO:
    31: 'Warten auf Vertragsunterzeichnung.',
    32: 'Neuen Mitarbeiter durch den Sachbearbeiter erstellen lassen.',
    33: 'Neuen Mitarbeiter erstellen.',
    34: 'Bewerbungsprozess beenden.',
    35: 'Vertrag per Post zum Bewerber gesendet.',
    36: 'Warten auf Posteingang (Vertrag).',
    37: 'Vertrag ist unterschrieben eingegangen, Entscheider informieren.',
    38: 'Vertrag muss noch vom Entscheider unterschrieben werden.',
    39: 'Vertrag liegt zum unterschreiben bereit.',
    40: 'Der vorliegende Vertrag muss vom Entscheider geändert werden.',
    41: 'Der vorliegende Vertrag muss vom Sachbearbeiter geändert werden.',
    42: 'Vertrag überarbeiten',
    43: 'Überarbeiteten Vertrag an den Entscheider gegeben.',
    44: 'Überarbeiteten Vertrag durchschauen.',
    45: 'Der Bewerber war nicht zu erreichen.',
    46: 'Bewerbung bearbeitet.',
    47: 'Anderen/Erneuten Kennenlerntag vereinbaren.',
    48: 'Anderen/Erneuten Vertragstermin vereinbaren.',
    49: 'Termin geändert & Bewerber informiert.',
    50: 'Dem Bewerber absagen.',
    51: 'Absage zurückziehen',
};

export const enrolmentState: { [key: string]: number } = {
    aplInsufficientData: -1,
    start: 0,
    mcInit: 1,
    boCancel: 2,
    boCheckQuestions: 3,
    boSetAppointment: 4,
    aplUnreachable: 5,
    mcQuestionsSolved: 6,
    aplAppointment: 7,
    cancel: 8,
    boSetTrialDay: 9,
    mcAplTrialDay: 10,
    aplWithdrewEnrolment: 11,
    boSetContractAppointment: 12,
    // mcAdditionalTrialDay: 13,
    waitingContractSigning: 14,
    createNewEmployee: 15,
    waitingContractReturn: 16,
    mcContractSigned: 17,
    mcChangeContract: 18,
    boChangeContract: 19,
    mcContractDecision: 20,
    paused: 21,
    unpaused: 22,
    reverted: 23,
    boSetAdditionalAppointment: 24,
    aplAdditionalAppointment: 25,
    automatedCancel: 26,
    boAutomatedCancel: 27,
    mcCancel: 28,
    mcAutomatedCancel: 29,
};

export const applicationStatus: { [key: string]: number } = {
    inactive: 0,
    active: 1,
    paused: 2,
};

export const applyOnWebsiteOptions: { [key: string]: number } = {
    default: 1,
    no: 2,
    yes: 3,
};

export const captchaVariants: { [key: string]: number } = {
    google: 1,
    ascii: 2,
};

export const enrolmentStates: {} = {
    [enrolmentState.aplInsufficientData]: {
        name: 'Fehlende Informationen',
        icon: 'warning',
        iconDescription: 'Unvollständige Bewerbung',
        caption: true,
        states: {
            [enrolmentState.aplInsufficientData]: {
                name: statusText[46],
                type: 'proceed',
                messageRequired: 1,
            },
            [enrolmentState.boCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.boAutomatedCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    // TODO @ludwig erase?
    [enrolmentState.start]: {
        name: 'Kann Raus',
        icon: null,
        states: {
            [enrolmentState.mcInit]: statusText[5],
        },
    },
    [enrolmentState.mcInit]: {
        name: 'Bewerbung prüfen',
        icon: 'reply',
        iconDescription: 'Weitergeleitet',
        caption: true,
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.boSetAppointment]: {
                name: statusText[4],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.boCheckQuestions]: {
        name: 'Rückfragen',
        icon: 'help',
        iconDescription: 'Rückfragen',
        states: {
            [enrolmentState.mcQuestionsSolved]: {
                name: statusText[11],
                type: 'proceed',
                messageRequired: 1,
            },
            [enrolmentState.aplUnreachable]: {
                name: statusText[45],
                type: 'proceed',
            },
            [enrolmentState.boCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.boAutomatedCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.mcQuestionsSolved]: {
        name: 'Fragen geklärt',
        icon: 'reply',
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.boSetAppointment]: {
                name: statusText[4],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.boSetAppointment]: {
        name: 'Bewerbungsgespräch vereinbaren',
        icon: 'contact_phone',
        iconDescription: 'In Terminvereinbarung',
        states: {
            [enrolmentState.aplAppointment]: {
                name: statusText[15],
                type: 'proceed',
            },
            [enrolmentState.aplUnreachable]: {
                name: statusText[14],
                type: 'proceed',
                hideOnAppointment: true,
            },
            [enrolmentState.boCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.boAutomatedCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.aplAppointment]: {
        name: 'Bewerbungsgespräch',
        icon: 'record_voice_over',
        iconDescription: 'Bewerbungsgespräch',
        caption: true,
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.aplAppointment]: {
                name: statusText[49],
                type: 'proceed',
            },
            [enrolmentState.boSetAdditionalAppointment]: {
                name: statusText[17],
                type: 'proceed',
            },
            [enrolmentState.boSetTrialDay]: {
                name: statusText[18],
                type: 'proceed',
            },
            [enrolmentState.boSetContractAppointment]: {
                name: statusText[25],
                type: 'proceed',
            },
            [enrolmentState.waitingContractReturn]: {
                name: statusText[35],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.boSetAdditionalAppointment]: {
        name: 'Erneutes Bewerbungsgespräch vereinbaren.',
        icon: 'contact_phone',
        iconDescription: 'In Terminvereinbarung',
        states: {
            [enrolmentState.aplAdditionalAppointment]: {
                name: statusText[15],
                type: 'proceed',
            },
            [enrolmentState.aplUnreachable]: {
                name: statusText[14],
                type: 'proceed',
                hideOnAppointment: true,
            },
            [enrolmentState.boCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.boAutomatedCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.aplAdditionalAppointment]: {
        name: 'Weiteres Bewerbungsgespräch',
        icon: 'record_voice_over',
        iconDescription: 'Bewerbungsgespräch',
        caption: true,
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.aplAdditionalAppointment]: {
                name: statusText[49],
                type: 'proceed',
            },
            [enrolmentState.boSetAdditionalAppointment]: {
                name: statusText[17],
                type: 'proceed',
            },
            [enrolmentState.boSetTrialDay]: {
                name: statusText[18],
                type: 'proceed',
            },
            [enrolmentState.boSetContractAppointment]: {
                name: statusText[25],
                type: 'proceed',
            },
            [enrolmentState.waitingContractReturn]: {
                name: statusText[35],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.boSetTrialDay]: {
        name: 'Kennenlerntag vereinbaren',
        icon: 'contact_phone',
        states: {
            [enrolmentState.mcAplTrialDay]: {
                name: statusText[22],
                type: 'proceed',
            },
            [enrolmentState.boCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.boAutomatedCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.mcAplTrialDay]: {
        name: 'Kennenlerntag',
        icon: 'work',
        iconDescription: 'Kennenlerntag',
        caption: true,
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.mcAplTrialDay]: {
                name: statusText[49],
                type: 'proceed',
            },
            [enrolmentState.boSetTrialDay]: {
                name: statusText[47],
                type: 'proceed',
            },
            [enrolmentState.boSetContractAppointment]: {
                name: statusText[25],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.boSetContractAppointment]: {
        name: 'Vertragsunterzeichnung vereinbaren',
        icon: 'contact_phone',
        states: {
            [enrolmentState.waitingContractSigning]: {
                name: statusText[30],
                type: 'proceed',
            },
            [enrolmentState.boCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.boAutomatedCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.waitingContractSigning]: {
        name: 'Vertragsunterzeichnung',
        icon: 'spellcheck',
        iconDescription: 'Vertrag',
        caption: true,
        states: {
            [enrolmentState.waitingContractSigning]: {
                name: statusText[49],
                type: 'proceed',
            },
            [enrolmentState.boSetContractAppointment]: {
                name: statusText[48],
                type: 'proceed',
            },
            [enrolmentState.createNewEmployee]: {
                name: statusText[32],
                type: 'proceed',
            },
            [enrolmentState.boChangeContract]: {
                name: statusText[41],
                type: 'proceed',
                messageRequired: 1,
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.boChangeContract]: {
        name: 'Vertragsänderung',
        icon: 'format_align_justify',
        iconDescription: 'Vertragsänderung',
        states: {
            [enrolmentState.mcContractDecision]: {
                name: statusText[43],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.mcContractDecision]: {
        name: 'Vertragsänderung durchsehen',
        icon: 'reply',
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.boChangeContract]: {
                name: statusText[41],
                type: 'proceed',
                messageRequired: 1,
            },
            [enrolmentState.boSetContractAppointment]: {
                name: statusText[25],
                type: 'proceed',
            },
            [enrolmentState.waitingContractReturn]: {
                name: statusText[35],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.waitingContractReturn]: {
        name: 'Vertragsunterzeichnung, warten auf Posteingang',
        icon: 'contact_mail',
        iconDescription: 'Warten auf Posteingang',
        states: {
            [enrolmentState.mcContractSigned]: {
                name: statusText[37],
                type: 'proceed',
            },
            [enrolmentState.mcChangeContract]: {
                name: statusText[40],
                type: 'proceed',
                messageRequired: 1,
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.mcChangeContract]: {
        name: 'Vertragsänderung veranlassen',
        icon: 'format_align_justify',
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.boSetContractAppointment]: {
                name: statusText[25],
                type: 'proceed',
            },
            [enrolmentState.waitingContractReturn]: {
                name: statusText[35],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.mcContractSigned]: {
        name: 'Vertragsunterzeichnung abgeschlossen',
        icon: 'note',
        iconDescription: 'Vertrag liegt zum Unterschreiben bereit',
        states: {
            [enrolmentState.boCheckQuestions]: {
                name: statusText[2],
                type: 'proceed',
                messageRequired: 1,
                mainContactOnly: 1,
            },
            [enrolmentState.createNewEmployee]: {
                name: statusText[32],
                type: 'proceed',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.createNewEmployee]: {
        name: 'Mitarbeiter erstellen',
        icon: 'person_add',
        iconDescription: 'Mitarbeiter/in erstellen',
        caption: true,
        states: {
            [enrolmentState.boCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.boAutomatedCancel]: {
                name: statusText[12],
                type: 'cancel',
            },
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.paused]: {
        name: 'Pausiert',
        icon: 'pause',
        states: {},
    },
    [enrolmentState.unpaused]: {
        name: 'Pausierung beendet',
        icon: 'play_arrow',
        states: {},
    },
    [enrolmentState.aplUnreachable]: {
        name: 'Bewerber nicht erreicht',
        icon: 'reply',
        states: {
            [enrolmentState.mcCancel]: {
                name: statusText[1],
                type: 'cancel',
            },
            [enrolmentState.mcAutomatedCancel]: {
                name: statusText[50],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
        },
    },
    [enrolmentState.boCancel]: {
        name: 'Bewerber absagen',
        icon: 'cancel',
        iconDescription: 'Bewerber/in absagen',
        states: {
            [enrolmentState.mcInit]: {
                name: statusText[8],
                type: 'proceed',
            },
            [enrolmentState.cancel]: {
                name: statusText[9],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
            // CARE! IF CHANGED NEEDS TO CHANGED IN APPLICATIONS LIB AS WELL , AS ITS A HARDCODED CONTROL-VALUE
        },
    },
    [enrolmentState.boAutomatedCancel]: {
        name: 'Absagen',
        icon: null,
        states: {
            [enrolmentState.reverted]: {
                name: statusText[51],
                type: 'proceed',
                hideOnExpiredTimer: true,
                showExpirationTimer: true,
            },
            [enrolmentState.mcInit]: {
                name: statusText[8],
                type: 'proceed',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
                hideOnExpiredTimer: true,
            },
        },
    },
    [enrolmentState.mcCancel]: {
        name: 'Bewerber absagen',
        icon: 'cancel',
        iconDescription: 'Bewerber/in absagen',
        states: {
            [enrolmentState.mcInit]: {
                name: statusText[8],
                type: 'proceed',
            },
            [enrolmentState.cancel]: {
                name: statusText[9],
                type: 'cancel',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
            },
            // CARE! IF CHANGED NEEDS TO CHANGED IN APPLICATIONS LIB AS WELL , AS ITS A HARDCODED CONTROL-VALUE
        },
    },
    [enrolmentState.mcAutomatedCancel]: {
        name: 'Absagen',
        icon: null,
        states: {
            [enrolmentState.reverted]: {
                name: statusText[51],
                type: 'proceed',
                hideOnExpiredTimer: true,
                showExpirationTimer: true,
            },
            [enrolmentState.mcInit]: {
                name: statusText[8],
                type: 'proceed',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
                hideOnExpiredTimer: true,
            },
        },
    },
    [enrolmentState.automatedCancel]: {
        name: 'Absagen',
        icon: null,
        states: {
            [enrolmentState.reverted]: {
                name: statusText[51],
                type: 'proceed',
                hideOnExpiredTimer: true,
                showExpirationTimer: true,
            },
            [enrolmentState.mcInit]: {
                name: statusText[8],
                type: 'proceed',
            },
            [enrolmentState.aplWithdrewEnrolment]: {
                name: statusText[6],
                type: 'cancel',
                hideOnExpiredTimer: true,
            },
        },
    },
    [enrolmentState.cancel]: {
        name: 'Absagen',
        icon: null,
        states: {
            [enrolmentState.mcInit]: {
                name: statusText[8],
                type: 'proceed',
            },
        },
    },
    [enrolmentState.aplWithdrewEnrolment]: {
        name: 'Absage durch Bewerber',
        icon: null,
        states: {
            [enrolmentState.mcInit]: {
                name: statusText[8],
                type: 'proceed',
            },
        },
    },
};

export const enrolmentPhase: { [key: string]: string } = {
    unassigned: 'unassigned',
    newApplication: 'new_application',
    screening: 'screening',
    jobInterview: 'job_interview',
    acquaintDay: 'acquaint_day',
    decision: 'decision',
    canceled: 'canceled',
    approved: 'approved',
    hired: 'hired',
    additionalJobInterviews: 'additional_job_interview',
    subRemaining: 'sub_open',
    subDone: 'sub_set',
};

export const enrolmentPhases: {} = {
    [enrolmentPhase.newApplication]: {
        name: 'Offene Rückfragen',
        children: {},
        states: [
            enrolmentState.aplInsufficientData,
            enrolmentState.boCheckQuestions,
        ],
    },
    [enrolmentPhase.screening]: {
        name: 'Bewerbung prüfen',
        children: {},
        states: [
            enrolmentState.start,
            enrolmentState.mcInit,
            enrolmentState.mcQuestionsSolved,
        ],
    },
    [enrolmentPhase.jobInterview]: {
        name: 'Bewerbungsgespräch',
        children: {
            [enrolmentPhase.subRemaining]: {
                name: 'Termin offen',
            },
            [enrolmentPhase.subDone]: {
                name: 'Termin steht',
            },
        },
        states: [
            enrolmentState.boSetAppointment,
            enrolmentState.aplAppointment,
        ],
    },
    [enrolmentPhase.additionalJobInterviews]: {
        name: 'Weiteres Bewerbungsgespräch',
        children: {
            [enrolmentPhase.subRemaining]: {
                name: 'Termin offen',
            },
            [enrolmentPhase.subDone]: {
                name: 'Termin steht',
            },
        },
        states: [
            enrolmentState.boSetAppointment,
            enrolmentState.aplAppointment,
        ],
    },
    [enrolmentPhase.acquaintDay]: {
        name: 'Kennenlerntag',
        children: {
            [enrolmentPhase.subRemaining]: {
                name: 'Termin offen',
            },
            [enrolmentPhase.subDone]: {
                name: 'Termin steht',
            },
        },
        states: [
            enrolmentState.boSetTrialDay,
            enrolmentState.mcAplTrialDay,
        ],
    },
    [enrolmentPhase.decision]: {
        name: 'Entscheidung',
        children: {},
        states: [
            enrolmentState.aplAppointment,
            enrolmentState.mcAplTrialDay,
            enrolmentState.aplUnreachable,
        ],
    },
    [enrolmentPhase.canceled]: {
        name: 'Absage',
        children: {
            [enrolmentPhase.subRemaining]: {
                name: 'Offen',
                states: [
                    enrolmentState.boCancel,
                ],
            },
            [enrolmentPhase.subDone]: {
                name: 'Erledigt',
                states: [
                    enrolmentState.aplWithdrewEnrolment,
                    enrolmentState.cancel,
                ],
            },
        },
        states: [
            enrolmentState.boCancel,
            enrolmentState.aplWithdrewEnrolment,
            enrolmentState.cancel,
        ],
    },
    [enrolmentPhase.approved]: {
        name: 'Zugesagt',
        children: {},
        states: [
            enrolmentState.boSetContractAppointment,
            enrolmentState.waitingContractSigning,
            enrolmentState.waitingContractReturn,
            enrolmentState.mcContractSigned,
            enrolmentState.mcChangeContract,
            enrolmentState.boChangeContract,
            enrolmentState.mcContractDecision,
        ],
    },
    [enrolmentPhase.hired]: {
        name: 'Eingestellt',
        children: {},
        states: [
            enrolmentState.createNewEmployee,
        ],
    },
};

export const socialLinkRequired: string[] = [
    'instagram',
];

export const exportVariant: { [key: string]: number } = {
    none: 1,
    webForm: 2,
    file: 3,
    fileAndWebForm: 4,
    default: 5,
};

// these placeholders are not allowed in mail templates for automated settings
export const invalidAutomatedPlaceholders: { [key: string]: string } = {
    appointment_day: 'Wochentag (Termin)',
    appointment_date: 'Datum (Termin)',
    appointment_time: 'Uhrzeit (Termin)',
};

export const signaturePositions: { [key: string]: number } = {
    top: 0,
    bottom: 1,
};

@Component
export default class AEnrolmentComponent extends Vue
{
    get isFreeEnrolment()
    {
        return isFreeEnrolment();
    }

    get insightAttributes()
    {
        return this.isFreeEnrolment ? INSIGHT_ATTRIBUTES : {};
    }
}

export function isFreeEnrolment(): boolean
{
    return store.state.layoutData.employee_configuration?.enrolment_version === 0;
}

// only the application phase 'screening' (called 'STATE_MC_INIT' in php) is allowed in enrolment free version
export function isAllowedPhase(phase: string): boolean
{
    return !isFreeEnrolment() || phase === enrolmentPhase.screening;
}

// returns the class and tooltip for disabling phases used in pipeline views
export function getPhaseTooltip(phaseId: string)
{
    return isAllowedPhase(phaseId) ? {} : INSIGHT_ATTRIBUTES;
}

// displayed if a user manages to access functions locked in enrolment free version
export function showFreeVersionMessage()
{
    TopMessageHandler.info('Diese Funktion steht in der kostenpflichtigen Version zur Verfügung.');
}

// checks the content (coming from ck-editor) if it contains placeholders not allowed in mail templates for automated settings
export function checkForInvalidPlaceholders(string: string): boolean
{
    let matched = false;

    for (let placeholder in invalidAutomatedPlaceholders)
    {
        if (string.indexOf('[[' + placeholder + ']]') !== -1)
        {
            matched = true;
            break;
        }
    }

    return matched;
}

export function getInvalidPlaceholders(string: string): string[]
{
    let placeholders = [];

    for (let placeholder in invalidAutomatedPlaceholders)
    {
        if (invalidAutomatedPlaceholders.hasOwnProperty(placeholder) && string.indexOf('[[' + placeholder + ']]') !== -1)
        {
            placeholders.push(invalidAutomatedPlaceholders[placeholder]);
        }
    }

    return placeholders;
}

export function getFormattedAddress(applicationEntry: ApplicationEntry): string
{
    let formattedAddress = applicationEntry.street;

    if (formattedAddress && applicationEntry.street_number)
    {
        formattedAddress += ' ' + applicationEntry.street_number;
    }

    if (applicationEntry.street_addition)
    {
        if (formattedAddress)
        {
            formattedAddress += ', ';
        }

        formattedAddress += applicationEntry.street_addition;
    }

    if (applicationEntry.postcode)
    {
        if (formattedAddress)
        {
            formattedAddress += ', ';
        }

        formattedAddress += applicationEntry.postcode;
    }

    if (applicationEntry.city)
    {
        if (formattedAddress)
        {
            if (applicationEntry.postcode)
            {
                formattedAddress += ' ';
            }
            else
            {
                formattedAddress += ', ';

            }
        }

        formattedAddress += applicationEntry.city;
    }

    if (applicationEntry.country)
    {
        if (formattedAddress)
        {
            formattedAddress += ', ';
        }

        formattedAddress += applicationEntry.country;
    }

    if (formattedAddress)
    {
        return formattedAddress;
    }
    else
    {
        return '';
    }
}

// TODO @ludwig add enrolment entry interface, difficult because used in various components with different enrolment interfaces...
export function changeEnrolmentStatus(enrolment: any): Promise<any>
{
    return new Promise((resolve, reject) =>
    {
        sendPopupRequest({
            type: 'changeStatus' + (enrolment.active ? 'Deactivate' : 'Activate'),
            url: '/employee/enrolment/enrolment/change-status/id/' + enrolment.id,
            data: {
                id: enrolment.id,
            },
            message: {
                message: 'Sind Sie sicher, dass Sie die Stellenausschreibung "<strong>' + enrolment.description
                    + '<' + '/strong>" ' + (enrolment.active ? 'deaktivieren' : 'aktivieren') + ' möchten?',
            },
            options: {
                titleIcon: 'library_books',
                textIcon: enrolment.active ? 'remove_circle' : 'check_circle',
                textIconClass: enrolment.active ? 'text-danger' : 'text-success',
                buttonOkay: {
                    title: enrolment.active ? 'Deaktivieren' : 'Aktivieren',
                    icon: 'remove_circle',
                    type: enrolment.active ? 'danger' : 'success',
                },
            },
        })
        .then(resolve)
        .catch((e) =>
        {
            reject();
            e !== 'popupClosed' && TopMessageHandler.error('Die Stellenausschreibung konnte nicht deaktiviert werden.');
        });
    });
}

export function unpausePrompt(application: ApplicationEntry): Promise<number|string|void>
{
    if (application.pause_date === null)
    {
        return Promise.resolve(0);
    }

    return new Promise((resolve, reject) =>
    {
        let date = dateHelper('d.m.Y', application.pause_date);

        let popup = new Popup(Object.assign({
            title: 'Achtung',
            titleIcon: 'person',
            textIcon: 'error',
            textIconClass: 'text-muted',
            text: `Die Bewerbung ist momentan bis zum <strong>${date}</strong> pausiert. Wenn Sie den Status der Bewerbung ändern wollen, wird die Pausierung der Bewerbung <strong>automatisch beendet</strong>. Wollen Sie fortfahren?`,
            size: 'small',
            closable: false,
            buttons: [
                {
                    title: 'Ja',
                    icon: 'check',
                    type: 'success',
                    cmd: () =>
                    {
                        popup.close();
                        resolve();
                    },
                },
                {
                    title: 'Nein',
                    icon: 'clear',
                    cmd: () =>
                    {
                        popup.close();
                        reject('popupClosed');
                    },
                },
            ],
        }));

        popup.open();
    });
}

export function revertToPreviousPhasePrompt(application: ApplicationEntry): Promise<void>
{
    return new Promise((resolve, reject) =>
    {
        let popup = new Popup(Object.assign({
            title: 'Achtung',
            titleIcon: 'person',
            textIcon: 'error',
            textIconClass: 'text-muted',
            text: `Sind Sie sicher, dass Sie die Bewerbung in die vorherige Phase <strong>${application.revert_status_name}</strong> verschieben möchten?`,
            size: 'small',
            closable: false,
            buttons: [
                {
                    title: 'Ja',
                    icon: 'check',
                    type: 'success',
                    cmd: () =>
                    {
                        popup.close();
                        resolve();
                    },
                },
                {
                    title: 'Nein',
                    icon: 'clear',
                    cmd: () =>
                    {
                        popup.close();
                        reject();
                    },
                },
            ],
        }));

        popup.open();
    });
}